import React, { useEffect, useState } from "react";
import "../css/backgrounds.css";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { getTapes } from "../js/toolsOptions";
import BotRightMenu from "./BotRightMenu";

export default function BotRight({ rightMenu }) {
  const [tapes, setTapes] = useState([]);

  useEffect(() => {
    let gotTapes = getTapes();
    let allTapes = [];

    for (let a = 0; a < gotTapes.length; a++) {
      allTapes.push(
        <button className="tapesButton" key={uuidv4()}>
          <img src={gotTapes[a]} alt="" />
        </button>
      );
    }

    setTapes(allTapes);
  }, []);

  const [canvases, setCanvases] = useState([]);

  useEffect(() => {
    axios({
      method: "GET",
      url: "/wp-json/artpad/v1/data",
    }).then((response) => {
      let channels = response.data.Channels;
      let allCanvases = [];
      let row = [];
      let rows = [];

      for (let a = 0; a < channels.length; a++) {
        let canvases1 = channels[a].Canvases;

        for (let b = 0; b < canvases1.length; b++) {
          let canvases2 = canvases1[b].canvases;
          let canvases2Length = canvases2.length;

          for (let c = 0; c < canvases2Length; c++) {
            allCanvases.push(canvases2[c].big);
          }
        }
      }
      let canvasesLength = allCanvases.length;

      for (let a = 0; a < canvasesLength; a++) {
        row.push(
          <button className="canvasesButton" key={uuidv4()}>
            <img src={allCanvases[a]} alt="" />
          </button>
        );

        if (row.length % 6 === 0) {
          rows.push(
            <div className="row" key={uuidv4()}>
              {[...row]}
            </div>
          );
          row = [];
        } else if (canvasesLength - 1 === a) {
          rows.push(
            <div className="row" key={uuidv4()}>
              {[...row]}
            </div>
          );
        }
      }

      setCanvases(rows);
    });
  }, []);

  return (
    <BotRightMenu
      content={rightMenu === "canvases" ? canvases : tapes}
      type={rightMenu === "canvases" ? "canvases" : "tapes"}
    />
  );
}
